// src/frontend/js/modern/core/event-bus.js
//const mitt = window.mitt;
import mitt from 'mitt';

import { EVENTS } from '../shared/constants.js';

class EventBus {
	constructor() {
		this._bus = mitt();
		this._listeners = new Map();

		this._eventHistory = [];
		this._maxHistory = 100;
	}

	on(event, callback) {
		this._bus.on(event, callback);
		if (!this._listeners.has(event)) {
			this._listeners.set(event, new Set());
		}
		this._listeners.get(event).add(callback);
		return this;
	}

	off(event, callback) {
		this._bus.off(event, callback);
		if (this._listeners.has(event)) {
			this._listeners.get(event).delete(callback);
		}
		return this;
	}

	emit(event, data = {}) {
		const payload = {
			...data,
			_meta: {
				timestamp: Date.now(),
				event: event,
				source: 'modern',
			},
		};

		console.log(`[EventBus] → ${event}`, payload);

		this._eventHistory.push({ event, payload, time: Date.now() });
		if (this._eventHistory.length > this._maxHistory) {
			this._eventHistory.shift();
		}
		this._bus.emit(event, payload);
		this._bus.emit(EVENTS.STATE_CHANGED, {
			event,
			data: payload,
		});
		return this;
	}

	once(event, callback) {
		const wrapper = (data) => {
			this.off(event, wrapper);
			callback(data);
		};
		this.on(event, wrapper);
		return this;
	}

	waitFor(event, timeout = 30000) {
		return new Promise((resolve, reject) => {
			const timer = setTimeout(() => {
				this.off(event, handler);
				reject(new Error(`Timeout waiting for: ${event}`));
			}, timeout);
			const handler = (data) => {
				clearTimeout(timer);
				this.off(event, handler);
				resolve(data);
			};
			this.on(event, handler);
		});
	}

	getHistory() {
		return this._eventHistory;
	}

	clear() {
		this._listeners.forEach((callbacks, event) => {
			callbacks.forEach(cb => this._bus.off(event, cb));
		});
		this._listeners.clear();
		this._eventHistory = [];
		return this;
	}

	listenerCount(event) {
		return this._listeners.get(event)?.size || 0;
	}
}

export const eventBus = new EventBus();
export { EVENTS };
export default eventBus;
